"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../");
var History_1 = require("../../Utils/History");
var VeriLiteWarningEvent = /** @class */ (function () {
    function VeriLiteWarningEvent(content, title, actions) {
        if (title === void 0) { title = ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.resources) === null || _b === void 0 ? void 0 : _b.Warning) || "Warning"; }
        if (actions === void 0) { actions = VeriLiteWarningEvent.DefaultActions(window.resources); }
        var _a, _b;
        this.content = content;
        this.title = title;
        this.actions = actions;
        this.color = "dark";
        this.backdrop = "static";
        this.closeOption = false;
        this.allowKeyboard = false;
    }
    VeriLiteWarningEvent.DefaultActions = function (resources) {
        var _a;
        return [
            new __1.VeriLiteEventAction(((_a = resources) === null || _a === void 0 ? void 0 : _a.Ok) || "Ok", "secondary", function (currentEvent, closeModalCallback) {
                closeModalCallback();
            })
        ];
    };
    return VeriLiteWarningEvent;
}());
exports.VeriLiteWarningEvent = VeriLiteWarningEvent;
exports.NeedToCalibrateScannerWarningEvent = function (resources) { return new VeriLiteWarningEvent(resources.Calibration_CalibrationDialogText, resources.Calibration_CalibrationDialogTitle, [
    new __1.VeriLiteEventAction(resources.Calibration_CalibrateNow, "primary", function (currentEvent, closeModalCallback) {
        closeModalCallback(function () { return History_1.default.push('/CalibrateScanner'); });
    }),
    new __1.VeriLiteEventAction(resources.Calibration_CalibrateLater, "secondary", function (currentEvent, closeModalCallback) {
        closeModalCallback();
    })
]); };
exports.ActionCannotBeUndone = function (resources, doPackRequest) { return new VeriLiteWarningEvent(resources.Confirm_MarkAsDeleteOrDestroy, resources.Confirm, [
    new __1.VeriLiteEventAction(resources.Yes, "primary", function (currentEvent, closeModalCallback) {
        doPackRequest();
        closeModalCallback(function () { });
    }),
    new __1.VeriLiteEventAction(resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
        closeModalCallback();
    })
]); };
exports.MultiClearConfirm = function (resources, onAction) { return new VeriLiteWarningEvent(resources.MultiClearScans_ComfirmMessage, resources.Confirm, [
    new __1.VeriLiteEventAction(resources.Yes, "primary", function (currentEvent, closeModalCallback) {
        onAction();
        closeModalCallback(function () { });
    }),
    new __1.VeriLiteEventAction(resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
        closeModalCallback();
    })
]); };
//# sourceMappingURL=WarningEvents.js.map